import { useMemo } from 'react';
import { SWS_HOST } from '@/constants';
import { useMarketOptions } from '../useMarketOptions';

type MarketPayload = {
  industry: string;
  sortBy?: string;
  id?: string;
  name?: string;
};

export const useHrefLangMarkets = (route: string, payload?: MarketPayload) => {
  const includeGlobal = false;
  const markets = useMarketOptions(includeGlobal, route, payload);

  const hrefLangMarkets = useMemo(() => {
    return markets.map((market) => (
      <link
        key={market.option}
        rel="alternate"
        hrefLang={`en-${market.option.toUpperCase()}`}
        href={`${SWS_HOST}${market.href}`}
      />
    ));
  }, [markets]);

  return {
    hrefLangMarkets,
  };
};
